import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-radio-selection-row',
  templateUrl: './radio-selection-row.component.html',
  styleUrl: './radio-selection-row.component.css'
})
export class RadioSelectionRowComponent implements OnInit, OnDestroy {
  @Input({ required: false }) label?: string;
  @Input({ required: true }) placeholder: string;
  @Input({ required: true }) errorMessage: string;
  @Input({ required: true }) control: FormControl;
  @Input({ required: false }) width = "30%";
  @Input({ required: true }) options: { label: string, value: string }[] = [];
  @Input({ required: false }) isResponsive = true;

  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {

  }

  isInvalid(): boolean {
    const control = this.control;
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }
}
